import { useQuery } from '@tanstack/react-query';

import { fetchPropertyAssessment } from 'api/propertyAssessment';

export const getKey = photoSessionId => ['remote-assessment', Number(photoSessionId)];

const useRemoteAssessment = (photoSessionId, options) =>
  useQuery({
    queryKey: getKey(photoSessionId),
    queryFn: () => fetchPropertyAssessment(photoSessionId),
    enabled: !!photoSessionId,
    ...options,
  });

export default useRemoteAssessment;
